import { createReducer } from "@reduxjs/toolkit";
import {
  EDIT_SYSTEM_LOCALIZATIONS,
  SYSTEM_LOCALIZATIONS_ERROR,
  SYSTEM_LOCALIZATIONS_LIST,
  SYSTEM_LOCALIZATIONS_LOADING,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
  allPages: 0,
  thisPage: 0,
};

const systemLocalizationsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SYSTEM_LOCALIZATIONS_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(SYSTEM_LOCALIZATIONS_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(SYSTEM_LOCALIZATIONS_LIST, (state, { payload }) => {
      state.loading = false;

      state.data =
        payload?.thisPage === 1
          ? payload.data
          : [...state.data, ...payload.data];
      state.allPages = payload.allPages;
      state.thisPage = payload.thisPage;
    })

    .addCase(EDIT_SYSTEM_LOCALIZATIONS, (state, { payload }) => {
      const index = state.data.findIndex((e) => e?.id === payload?.id);
      state.data[index] = payload;
      state.loading = false;
    });
});

export default systemLocalizationsReducer;
